import React from "react"
import { useToast } from "~/utils/Toast"

import useFetchResource from "~/hooks/useFetchResource"
import getAppConfig from "~/utils/getAppConfig"
import { apiVenues } from "~/routes"

import PageContainer from "~/library/PageContainer"
import LoadingWrapper from "~/library/LoadingWrapper"
import VenueForm from "~/components/VenueForm"
import Venue from "~/types/Venue"

const VenueSettings = () => {
  const { venueSlug } = getAppConfig()
  const toast = useToast()
  const endpoint = apiVenues.show.path({ venueSlug })
  const { data: venue, isLoading } = useFetchResource<{ venue: Venue }, "venue">(
    endpoint,
    "venue",
    {}
  )

  const handleSubmit = (formValues: Venue) => {
    const data = {
      venueSlug,
      venue: {
        name: formValues.name,
        slug: formValues.slug,
        contact_email: formValues.contactEmail?.trim() || null,
        categories: formValues.categories,
        currency: formValues.currency,

        address1: formValues.address1,
        address2: formValues.address2,
        city: formValues.city,
        state: formValues.state,
        postal_code: formValues.postalCode,
        country: formValues.country,

        enable_saved_payments: formValues.enableSavedPayments,
        enable_instant_payments: formValues.enableInstantPayments,
        allow_skip_payment: formValues.allowSkipPayment,

        enable_tax: formValues.enableTax,
        tax_rate: formValues.enableTax ? formValues.taxRate : null,

        enable_booking_surcharge: formValues.enableBookingSurcharge,
        booking_surcharge_rate: formValues.enableBookingSurcharge
          ? formValues.bookingSurchargeRate
          : null,

        logo_id: formValues.logo?.id,
      },
    }

    apiVenues
      .update({ data })
      .then(() => {
        window.location.replace(`/workspace/${encodeURIComponent(formValues.slug)}`)
      })
      .catch((res) => {
        toast(`Error updating Venue. ${res.body.errors.join(", ")}`, "danger")
      })
  }

  return (
    <PageContainer>
      <div className="row h-100">
        <div className="col-6 offset-3 align-center mt-4">
          <h3 className="mb-3">Edit Venue</h3>
          <LoadingWrapper isLoading={isLoading}>
            <VenueForm
              onSubmit={handleSubmit}
              initialValues={venue}
              isEditing
              venueSlug={venueSlug}
            />
          </LoadingWrapper>
        </div>
      </div>
    </PageContainer>
  )
}

export default VenueSettings
